import { DataRoom } from 'router/subrouters/DataRoom/models/DataRoom';

export type EnterpriseDataRoom = Pick<
  DataRoom,
  'dealRoom' | 'user' | 'hasDataRoomAccess' | 'createdAt'
>;

export const TABLE_COLUMNS: Array<keyof EnterpriseDataRoom> = [
  'dealRoom',
  'user',
  'hasDataRoomAccess',
  'createdAt',
];

export const HEADING_TRANSLATIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  dealRoom: 'name',
  user: 'owner',
  hasDataRoomAccess: 'access',
  createdAt: 'createdOn',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  dealRoom: 'sortName',
  user: 'sortOwnerName',
  createdAt: 'createdAt',
};

export const SIZE_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = { dealRoom: 170, user: 170, hasDataRoomAccess: 160, createdAt: 130 };

export const LIMIT = '10';
